import { render, staticRenderFns } from "./ColourRadioButton.vue?vue&type=template&id=73dc4af2&scoped=true"
import script from "./ColourRadioButton.vue?vue&type=script&lang=js"
export * from "./ColourRadioButton.vue?vue&type=script&lang=js"
import style0 from "./ColourRadioButton.vue?vue&type=style&index=0&id=73dc4af2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73dc4af2",
  null
  
)

export default component.exports